<script setup>
const props = defineProps({
  lottie: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: false,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
  },
  cta: {
    type: Object,

    validate: (value) => {
      return typeof value.label === "string" && typeof value.path === "string";
    },
  },
});
</script>

<template>
  <div
    class="font-iq-paragraph leading-iq-paragraph tracking-iq-paragraph text-iq-paragraph-color"
  >
    <h4 v-if="subtitle" class="text-xs">
      {{ subtitle }}
    </h4>
    <h3
      class="text-4xl font-semibold mb-2 font-iq-header leading-iq-header tracking-iq-header text-iq-header-color md:text-center"
    >
      {{ title }}
    </h3>

    <FlexuilibMagicLottie
      :src="lottie"
      class="aspect-video rounded-iq-roundness w-full mb-6 mt-4 border border-slate-300 bg-white/50"
    />

    <p class="text-justify text-lg">
      <slot name="description">
        {{ description }}
      </slot>
    </p>

    <!-- Cta -->
    <slot name="cta">
      <div class="mt-8">
        <FlexuilibCta
          v-if="cta"
          :label="cta.label"
          :path="cta.path"
          :icon="cta?.icon"
          :type="cta?.type"
        />
      </div>
    </slot>
  </div>
</template>
